import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { settlementApi } from '../../../lib/api/settlement';
import {
  SettlementItemsBulkUpdateRequestBodyDto,
  SettlementItemsBulkUpdateResponseDto,
} from '../../../types/api/settlement-items';
import { settlementQuery } from '../queries';

export const useBulkUpdateSettlementItems = (
  request: SettlementItemsBulkUpdateRequestBodyDto['settlementItems'],
): UseMutationResult<SettlementItemsBulkUpdateResponseDto, unknown, void, unknown> => {
  const queryClient = useQueryClient();

  const mutate = useMutation({
    mutationFn: () => settlementApi.bulkUpdateSettlementItems({ settlementItems: request }),
    onSuccess: async () => {
      await queryClient.invalidateQueries(settlementQuery.list._def);
    },
    onError: async () => {
      await queryClient.invalidateQueries(settlementQuery.list._def);
    },
  });

  return mutate;
};
